let instantStyleKilled = false;
function killInstantStyle() {
  if (instantStyleKilled) return;
  const s = document.getElementById("instant-tab-style");
  if (s) s.remove();
  instantStyleKilled = true;
}

function openCity(evt, id) {
  // Hide all tab contents
  document.querySelectorAll(".tabcontent").forEach(el => el.classList.remove("is-active"));
  // Remove active on all links
  document.querySelectorAll(".tablinks").forEach(b => b.classList.remove("active"));

  // Show chosen tab and mark active button
  document.getElementById(id)?.classList.add("is-active");
  if (evt?.currentTarget) {
    evt.currentTarget.classList.add("active");
  } else {
    const btn = document.querySelector(`.tablinks[onclick*="'${id}'"]`);
    if (btn) btn.classList.add("active");
  }

  // Save for next load
  localStorage.setItem("activeTab", id);

  // Remove injected instant style now that we're interactive
  killInstantStyle();
}

function getInitialId() {
  const saved = localStorage.getItem("activeTab");
  if (saved && document.getElementById(saved)) return saved;

  const fallbackBtn = document.getElementById("defaultOpen");
  if (fallbackBtn) {
    const m = (fallbackBtn.getAttribute("onclick") || "").match(/'(.*?)'/);
    if (m && document.getElementById(m[1])) return m[1];
  }

  const first = document.querySelector(".tabcontent[id]");
  return first ? first.id : null;
}

document.addEventListener("DOMContentLoaded", () => {
  const id = getInitialId();
  if (!id) {
    killInstantStyle();
    return;
  }

  // Make it visible immediately
  document.getElementById(id).classList.add("is-active");

  // Finalize class states after render
  requestAnimationFrame(() => openCity(null, id));
});